import CaseStudy from './CaseStudy';
export default CaseStudy;